export const IS_CREATE_CAMPAIGN = "IS_CREATE_CAMPAIGN";
export const CAMPAIGN_LIST = "CAMPAIGN_LIST";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_DELETED = "AFTER_DELETED";
export const CAMPAIGN_DETAILS = "CAMPAIGN_DETAILS";
export const ADDING_CAMPAIGN_PRODUCTS = "ADDING_CAMPAIGN_PRODUCTS";
export const ADDED_CAMPAIGN_PRODUCTS = "ADDED_CAMPAIGN_PRODUCTS";
